module.exports = new __parcel__URL__("button1.3460f251.wav").toString();